import { useState } from "react";

import { Link } from "react-router-dom";

import "../AuthShared.scss";
import niraLogoLong from "../../assets/NIRALogo_long.webp";
import { forgotPassword } from "../../services/auth";
import { logger } from "../../utils/logger";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setLoading(true);
    setErrorMsg("");

    try {
      await forgotPassword(email.trim());
      setSubmitted(true);
    } catch (error) {
      logger.error("Forgot password submit error", { error, context: "ForgotPassword" });
      setErrorMsg(error instanceof Error ? error.message : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="geometric-vector-wrapper">
        <div className="geometric-vector"></div>
      </div>
      <div className="geometric-vector-wrapper">
        <div className="geometric-vector-1"></div>
      </div>
      <div className="geometric-vector-wrapper">
        <div className="geometric-vector-2"></div>
      </div>
      <div className="depth-effect-overlay"></div>

      <div className="auth-card-container">
        <div className="auth-card">
          <img src={niraLogoLong} alt="NIRA Logo" className="auth-logo" />
          <div className="auth-powered-by">Powered by: Diem360</div>

          {submitted ? (
            <>
              <h2 className="auth-title">Check Your Email</h2>
              <p className="auth-subtitle">
                If an account exists for <strong>{email}</strong>, we&apos;ve sent a password reset link.
                Please check your inbox and spam folder.
              </p>
              <Link to="/login" className="auth-back-link">
                Back to Login
              </Link>
            </>
          ) : (
            <>
              <h2 className="auth-title">Forgot Password</h2>
              <p className="auth-subtitle">
                Enter your email address and we&apos;ll send you a link to reset your password.
              </p>

              {errorMsg && (
                <div className="auth-message auth-message--error">{errorMsg}</div>
              )}

              <form className="auth-form" onSubmit={handleSubmit}>
                <div className="auth-input-group">
                  <input
                    type="email"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                    autoFocus
                  />
                </div>
                <button
                  type="submit"
                  className="auth-submit-btn"
                  disabled={loading || !email.trim()}
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </button>
              </form>

              <Link to="/login" className="auth-back-link">
                Back to Login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
